<template>
  <div ref="wrap" class="lazy-list" :style="{ height: `${height}px` }">
    <slot />
    <mugen-scroll
      :handler="fetchHandler"
      :should-handle="!pageLoading && !allDataLoaded"
      scroll-container="wrap"
    >
      <scroll-loader :all-data-loaded="allDataLoaded" />
    </mugen-scroll>
  </div>
</template>

<script>
import MugenScroll from 'vue-mugen-scroll'
import ScrollLoader from '@/components/loaders/scroll-loader'

export default {
  props: {
    height: {
      type: Number,
      required: true
    },
    pageLoading: {
      type: Boolean,
      required: true
    },
    allDataLoaded: {
      type: Boolean,
      required: true
    },
    fetchHandler: {
      type: Function,
      required: true
    }
  },
  components: {
    MugenScroll,
    ScrollLoader
  }
}
</script>

<style lang="less">
.lazy-list {
  overflow: auto;
  padding-right: 8px;
}
</style>
